import { documentConstants } from "../_constants/documents.constants";
import { DocumentApi } from "../_services";

const accountDocumentsInitialState = {
    accountDocumentsLoading: false,
    allDocsAccepted: false,
    idDocumentsLoading: false,
    accountDocuments: [],
    accountDocsRejected: false,
    idDocsRejected: false,
    idDocuments: [],
    documentImg: "",
    accountDocumentError: "",
    idDocumentError: "",
    imgLoading: false,
    fetchImgError: "",
    documentByHashLoading: false,
    documentHash: '',
    documentDetails: {},
    documentByHashId: '',
    documentByHashError: '',
    documentByIdTokenError: '',
    documentByHash: [],
    documentByHashType: null,
    documentUpdateLoading : false,
    documentUpdatedId : null,
    isMyDocumentsEnabled : false,
}

export const accountDocumentsReducer = (state = accountDocumentsInitialState, action) => {
    const { accountDocuments, accountDocError, idDocError } = action;
    switch (action.type) {
      case documentConstants.ACCOUNT_DOCUMENTS_LOADING:
        return {
          ...state,
          accountDocumentsLoading: !state.accountDocumentsLoading,
        };
      case documentConstants.ACCOUNT_DOCUMENTS_SUCCESS:
        let accountDocsRejected = -1;
        accountDocsRejected = accountDocuments.findIndex(
          (x) => x.documentStatusId === 3
        );
        accountDocsRejected = accountDocsRejected > -1 ? true : false;
        return {
          ...state,
          accountDocuments: accountDocuments,
          accountDocsRejected,
        };
      case documentConstants.ACCOUNT_DOCUMENTS_FAILED:
        return {
          ...state,
          accountDocumentError: accountDocError,
        };
      case documentConstants.ID_DOCUMENTS_LOADING:
        return {
          ...state,
          idDocumentsLoading: !state.idDocumentsLoading,
        };
      case documentConstants.ID_DOCUMENTS_SUCCESS:
        let idDocsRejected = -1;
        let allDocsAccepted = -false;
        const {
          leadDocuments: {
            proofsOfIdentity,
            proofsOfResidence,
            proofsOfIncome,
            idDocuments,
            leadId,
            userHash,
          },
        } = action;
        idDocsRejected =
          idDocuments &&
          idDocuments.length &&
          idDocuments.findIndex((x) => x.documentStatusId === 3);
        idDocsRejected = idDocsRejected > -1;
        allDocsAccepted =
          idDocuments &&
          idDocuments.length &&
          idDocuments.find((doc) =>
            doc.documentStatusId !== 4 ? false : true
          );
        return {
          ...state,
          idDocuments,
          idDocsRejected,
          allDocsAccepted,
          proofsOfIdentity,
          proofsOfResidence,
          proofsOfIncome,
          leadId,
          userHash,
        };
      case documentConstants.ID_DOCUMENTS_FAILED:
        return {
          ...state,
          idDocumentError: idDocError,
        };
      case documentConstants.FETCH_DOCUMENT_IMG_BY_ID_LOADING:
        return {
          ...state,
          imgLoading: !state.imgLoading,
        };
      case documentConstants.FETCH_DOCUMENT_IMG_BY_ID_SUCCESS:
        return {
          ...state,
          documentImg: action.documentImg,
        };
      case documentConstants.FETCH_DOCUMENT_IMG_BY_ID_FAILED:
        return {
          ...state,
          fetchImgError: action.imgError,
        };
      case documentConstants.FETCH_DOCUMENT_BY_HASH_ID_LOADING:
        return {
          ...state,
          documentByHashLoading: !state.documentByHashLoading,
        };
      case documentConstants.CALCULATE_USER_HASH_SUCCESS:
        return {
          ...state,
          documentHash: action.data,
        };
      case documentConstants.CALCULATE_USER_HASH_FAILED:
        return {
          ...state,
          documentByHashError: action.errorString,
        };
      case documentConstants.FETCH_DOCUMENT_BY_ID_TOKEN_SUCCESS:
        return {
          ...state,
          documentByHashId: action.data,
        };
      case documentConstants.FETCH_DOCUMENT_BY_ID_TOKEN_FAILED:
        return {
          ...state,
          documentByIdTokenError: action.errorString,
        };
      case documentConstants.FETCH_DOCUMENT_BY_HASH_ID_SUCCESS: {
        // .data.documentType and .data.document
        let type =
          action.data.documentType === 0
            ? "Unknown"
            : action.data.documentType === 1
            ? "Image"
            : action.data.documentType === 2
            ? "PDF"
            : null;
        return {
          ...state,
          documentByHash: action.data.document,
          documentDetails: {
            documentTypeText: type,
          },
        };
      }
      case documentConstants.FETCH_DOCUMENT_BY_HASH_ID_FAILED:
        return {
          ...state,
          fetchImgError: action.errorString,
        };
      case documentConstants.ID_DOCUMENTS_UPDATED_LOADING: {
        const { documentUpdatedId } = action;
        return {
          ...state,
          documentUpdateLoading: !state.documentUpdateLoading,
          documentUpdatedId,
        };
      }
      case documentConstants.ID_DOCUMENTS_UPDATED_SUCCESS: {
        const { documentUpdated } = action;
        if (!documentUpdated) return { ...state };
        else
          return {
            ...state,
            idDocuments: [
              ...state.idDocuments.map((s) => {
                if (s.id == documentUpdated.id) {
                  s.isViewed = true;
                }
                return s;
              }),
            ],
          };
      }
      case documentConstants.ID_DOCUMENTS_UPDATED_FAILED: {
        return {
          ...state,
          documentUpdateError: action.errorString,
        };
      }
      case documentConstants.ID_DOCUMENTS_UPLOAD_SUCCESS: {
        const { documentUploaded } = action;
        let {
          idDocuments,
          proofsOfIdentity,
          proofsOfResidence,
          proofsOfIncome,
        } = state;

        switch (documentUploaded.documentClassificationId) {
          case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
            proofsOfIdentity = [documentUploaded, ...proofsOfIdentity];
            break;
          case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
            proofsOfResidence = [documentUploaded, ...proofsOfResidence];
            break;
          case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
            proofsOfIncome = [documentUploaded, ...proofsOfIncome];
            break;
          default:
            break;
        }
        return {
          ...state,
          idDocuments : [documentUploaded, ...idDocuments],
          proofsOfIdentity,
          proofsOfResidence,
          proofsOfIncome,
        }
      }
      case documentConstants.IS_MY_DOCUMENTS_ENABLED_SUCCESS: {
        return {
          ...state,
          isMyDocumentsEnabled: action.isMyDocumentsEnabled,
        };
      }
      case documentConstants.CLEAN_DOCUMENTS_STATE: {
        return {
          ...accountDocumentsInitialState,
        };
      }
      default:
        return state;
    }
}